'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  colors: {
    black: '#000',
    'near-black': '#111',
    'dark-gray': '#333',
    'mid-gray': '#555',
    gray: '#777',
    silver: '#999',
    'light-silver': '#aaa',
    'moon-gray': '#ccc',
    'light-gray': '#eee',
    'near-white': '#f4f4f4',
    white: '#fff',

    transparent: 'transparent',

    'black-90': 'rgba(0,0,0,.9)',
    'black-80': 'rgba(0,0,0,.8)',
    'black-70': 'rgba(0,0,0,.7)',
    'black-60': 'rgba(0,0,0,.6)',
    'black-50': 'rgba(0,0,0,.5)',
    'black-40': 'rgba(0,0,0,.4)',
    'black-30': 'rgba(0,0,0,.3)',
    'black-20': 'rgba(0,0,0,.2)',
    'black-10': 'rgba(0,0,0,.1)',
    'black-05': 'rgba(0,0,0,.05)',
    'black-025': 'rgba(0,0,0,.025)',
    'black-0125': 'rgba(0,0,0,.0125)',

    'white-90': 'rgba(255,255,255,.9)',
    'white-80': 'rgba(255,255,255,.8)',
    'white-70': 'rgba(255,255,255,.7)',
    'white-60': 'rgba(255,255,255,.6)',
    'white-50': 'rgba(255,255,255,.5)',
    'white-40': 'rgba(255,255,255,.4)',
    'white-30': 'rgba(255,255,255,.3)',
    'white-20': 'rgba(255,255,255,.2)',
    'white-10': 'rgba(255,255,255,.1)',
    'white-05': 'rgba(255,255,255,.05)',
    'white-025': 'rgba(255,255,255,.025)',
    'white-0125': 'rgba(255,255,255,.0125)',

    'dark-red': '#E7040F',
    red: '#FF4136',
    'light-red': '#FF725C',
    orange: '#FF6300',
    gold: '#FFB700',
    yellow: '#FFD700',
    'light-yellow': '#FBF1A9',
    purple: '#5E2CA5',
    'light-purple': '#A463F2',
    'dark-pink': '#D5008F',
    'hot-pink': '#FF41B4',
    pink: '#FF80CC',
    'light-pink': '#FFA3D7',
    'dark-green': '#137752',
    green: '#19A974',
    'light-green': '#9EEBCF',
    navy: '#001B44',
    'dark-blue': '#00449E',
    blue: '#357EDD',
    'light-blue': '#96CCFF',
    'lightest-blue': '#CDECFF',
    'washed-blue': '#F6FFFE',
    'washed-green': '#E8FDF5',
    'washed-yellow': '#FFFCEB',
    'washed-red': '#FFDFDF'
  },
  defaultScale: ['0', '.25rem', '.5rem', '1rem', '2rem', '4rem', '8rem', '16rem'],
  typeSizeScale: ['3rem', '2.25rem', '1.5rem', '1.25rem', '1rem', '.875rem'],
  measureScale: { '': '30em', wide: '34em', narrow: '20em' },
  lineHeightScale: { solid: 1, title: 1.25, copy: 1.5 },
  trackingScale: { '': '.1em', tight: '-.05em', mega: '.25em' },
  fontWeightScale: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  fontFamilies: {
    'sans-serif': '-apple-system, BlinkMacSystemFont, "avenir next", venir, "helvetica neue", elvetica, ubuntu, roboto, noto, "segoe ui", arial, sans-serif',
    serif: 'georgia, times, serif',
    'system-sans-serif': 'sans-serif',
    'system-serif': 'serif',
    code: 'Consolas, monaco, monospace',
    helvetica: '"helvetica neue", helvetica, sans-serif',
    avenir: '"avenir next", avenir, sans-serif',
    athelas: 'athelas, georgia, serif',
    georgia: 'georgia, serif',
    times: 'times, serif',
    bodoni: '"Bodoni MT", serif',
    calisto: '"Calisto MT", serif',
    garamond: 'garamond, serif',
    baskerville: 'baskerville, serif'
  },
  widthScale: ['1rem', '2rem', '4rem', '8rem', '16rem'],
  borderRadiusScale: ['0', '.125rem', '.25rem', '.5rem', '1rem'],
  boxShadows: {
    1: '0px 0px 4px 2px rgba( 0, 0, 0, 0.2 )',
    2: '0px 0px 8px 2px rgba( 0, 0, 0, 0.2 )',
    3: '2px 2px 4px 2px rgba( 0, 0, 0, 0.2 )',
    4: '2px 2px 8px 0px rgba( 0, 0, 0, 0.2 )',
    5: '4px 4px 8px 0px rgba( 0, 0, 0, 0.2 )'
  },
  mediaQueries: {
    ns: 'screen and (min-width: 30em)',
    md: 'screen and (min-width: 30em) and (max-width: 60em)',
    lg: 'screen and (min-width: 60em)'
  },
  applyStates: ['fontWeight', 'fontStyle', 'textDecoration', 'color', 'backgroundColor', 'borders', 'boxShadow']
};


//////////////////
// WEBPACK FOOTER
// ./~/reta/defaults.js
// module id = 351
// module chunks = 0